exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modify_tip_div[data-v-43ee73f4]{border:1px solid rgba(3,255,242,.33);border-radius:4px;padding:10px;background-color:rgba(3,255,242,.13);font-size:15px;line-height:25px}.modify_input_div[data-v-43ee73f4]{margin-top:5%;padding:2px;border-radius:4px;border:1px solid #e52212}.modify_input[data-v-43ee73f4]{font-size:15px}", ""]);

// exports
